import React from 'react';
import { useInView } from 'react-intersection-observer';
import DevpageSidebarPlacement from '../../../../DealerAd/Placement/DevpageSidebar';
import s from './Dealer.scss';
const Dealer = ()=>{
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true
    });
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: s['root']
    }, inView && /*#__PURE__*/ React.createElement(DevpageSidebarPlacement, null));
};
Dealer.displayName = 'Dealer';
export default Dealer;

//# sourceMappingURL=Dealer.js.map